import React, { useState, useEffect } from "react";
import GNavbar from "../../components/Navbar/S-Navigator";
import Mobile from "../../components/Navbar/Navbar";
import TopNav from "../../components/Navbar/SuperAdminNav";
import { Link, useNavigate } from "react-router-dom";
import {
  getCookie,
  HOST_URL,
  reqOptions,
  SK_VALUE,
} from "../../assets/js/helpFunction";
import Marketplace from "../../components/Marketplace/SuperAdminOnboarding";
import HomeService from "../../components/HomeService/SuperAdminOnboarding";
import Advert from "../../components/Advert/SuperAdminOnboarding";
import { downloadData } from "../../utils/downloadData";
import "./superadmin-overview.css";

const SuperIcon = ({ name, size = 18 }) => {
  const paths = {
    dashboard: "M4 13h6V4H4v9Zm0 7h6v-4H4v4Zm10 0h6v-9h-6v9Zm0-16v4h6V4h-6Z",
    estate: "M3 21h18M5 21V9l7-5 7 5v12M9 21v-6h6v6",
    advert: "M4 18v-4m0-4V6m4 10h12M8 8h12M4 6h4v8H4V6Zm12 2v6m-4-3h8",
    active: "m5 12 4 4L19 6",
    download: "M12 3v12m0 0 4-4m-4 4-4-4M4 20h16",
    chart: "M4 19V9m6 10V5m6 14v-7m4 7H2",
    trophy: "M8 4h8v4a4 4 0 0 1-8 0V4Zm0 2H4v1a4 4 0 0 0 4 4m8-5h4v1a4 4 0 0 1-4 4m-4 1v5m-4 3h8",
    arrow: "M5 12h14m-5-5 5 5-5 5",
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d={paths[name]} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
};

export const WithSuperAuth = ({ children, activeSection = "overview" }) => {
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  // if(getCookie("access") === null){
  //     loginRequired(401)
  // }

  useEffect(() => {
    // let requestOptions = reqOptions("get", null, true);
    // const api = `${HOST_URL()}estate_users/estate_user_detail/?estate_id=${getEstateID()}`;
    // fetch(api, requestOptions)
    // .then((res) => res.json())
    // .then((data) => {
    //     if(data.code === "user_not_found"){
    //         loginRequired(401)
    //     }else if(data.estate_user.user_type !== "ADMIN"){
    //         navigate("/my-estates")
    //     }else{
    //         setUser(data)
    //     }
    // })
    // .catch((err) => console.log(err));
  }, []);

  return (
    <section className="change_ratio">
      <GNavbar
        overview={activeSection === "overview" ? "active_tab" : ""}
        estate={activeSection === "estate" ? "active_tab" : ""}
        wallet={activeSection === "wallet" ? "active_tab" : ""}
        subscriptions={activeSection === "subscriptions" ? "active_tab" : ""}
      />
      <Mobile />
      <section className="selected_tab">
        <TopNav />
        <div className="dashboard_container">{children}</div>
      </section>
    </section>
  );
};

const Overview = () => {
  const [data, setData] = useState({});
  const [analyticsData, setAnalyticsData] = useState([]);
  const [advertData, setAdvertData] = useState([]);
  const [selectedEstate, setSelectedEstate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [advertLoading, setAdvertLoading] = useState(false);
  const estates = data?.estates?.results;
  const [userCodeAna, setUserCodeAna] = useState("");

  const [downLoading, setDownLoading] = useState(false);

  const selectedEstateData = estates?.find(
    (estate) => estate?.estate_id === selectedEstate
  );
  const activeEstates = estates?.filter((estate) => estate.status === "ACTIVE").length || 0;
  const inactiveEstates = estates?.filter((estate) => estate.status !== "ACTIVE").length || 0;

  useEffect(() => {
    if (estates?.length) {
      setSelectedEstate(estates?.[0]?.estate_id);
    }
  }, [estates]);

  useEffect(() => {
    if (selectedEstate) {
      setLoading(true);
      let myHeaders = new Headers();
      myHeaders.append("EstateIQ-Sk-Header", SK_VALUE());
      myHeaders.append("Authorization", "Bearer " + getCookie("access"));

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(
        HOST_URL() +
          `estate_access_logs/code-tracking/?estate_id=${selectedEstate}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => setAnalyticsData(data))
        .catch((error) => console.log("error", error))
        .finally(() => setLoading(false));

      fetch(
        HOST_URL() +
          `estate_access_logs/user-code-tracking/?estate_id=${selectedEstate}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => setUserCodeAna(data?.[0]))
        .catch((error) => console.log("error", error))
        .finally(() => setLoading(false));
    }
  }, [selectedEstate]);

  useEffect(() => {
    let myHeaders = new Headers();
    myHeaders.append("EstateIQ-Sk-Header", SK_VALUE());
    myHeaders.append("Authorization", "Bearer " + getCookie("access"));

    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    setAdvertLoading(true);

    fetch(HOST_URL() + `estate_adverts/analytics/`, requestOptions)
      .then((response) => response.json())
      .then((data) => setAdvertData(data?.adverts))
      .catch((error) => console.log("error", error))
      .finally(() => setAdvertLoading(false));
  }, []);

  useEffect(() => {
    const requestOptions = reqOptions("get", null, true);
    const estates_api = `${HOST_URL()}estates/super_admin/`;

    Promise.all([fetch(estates_api, requestOptions)])
      .then(function (responses) {
        return Promise.all(
          responses.map(function (response) {
            return response.json();
          })
        );
      })
      .then(function (resp) {
        setData({ ...data, estates: resp[0] });
      })
      .catch(function (error) {});
  }, []);

  const handleDownload = (type) => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}estate_adverts/analytics?limit=1000`;
    setDownLoading(true);
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data);
        const myData = data?.adverts?.map((data) => ({
          Title: `${data.title}`,
          "Business Name": `${data.business_name}`,
          Views: `${data.views}`,
          Clicks: `${data.clicks}`,
          Control: `${data.ctr}`,
        }));

        downloadData(myData, type, "Adverts Data");
      })
      .catch((err) => console.log("err", err))
      .finally(() => setDownLoading(false));
  };

  return (
    <WithSuperAuth>
      <main className="super-overview">
        <header className="super-overview-hero">
          <div><p className="super-overview-kicker"><SuperIcon name="dashboard" /> PLATFORM CONTROL CENTRE</p><h1>Super Admin Dashboard</h1><p>Monitor estates, platform activity and operational performance from one place.</p></div>
          <Link to="/superadmin/estates">Manage estates <SuperIcon name="arrow" /></Link>
        </header>

        <section className="super-overview-summary">
          <article><span className="blue"><SuperIcon name="estate" /></span><div><p>Total estates</p><strong>{data?.estates?.count || estates?.length || 0}</strong><small>Registered on the platform</small></div></article>
          <article><span className="green"><SuperIcon name="active" /></span><div><p>Active estates</p><strong>{activeEstates}</strong><small>Currently operating</small></div></article>
          <article><span className="amber"><SuperIcon name="estate" /></span><div><p>Inactive estates</p><strong>{inactiveEstates}</strong><small>Require review or activation</small></div></article>
          <article><span className="purple"><SuperIcon name="advert" /></span><div><p>Advert campaigns</p><strong>{advertData?.length || 0}</strong><small>Tracked campaigns</small></div></article>
        </section>

        <section className="super-overview-quick-actions">
          <div><span>QUICK ACTIONS</span><h2>Platform publishing</h2><p>Create and manage content visible across EstateIQ services.</p></div>
          <div className="super-overview-action-buttons"><Marketplace /><HomeService /><Advert /></div>
        </section>

        <section className="super-overview-card super-overview-adverts">
          <div className="super-overview-card-head"><div><span>CAMPAIGN INSIGHTS</span><h2>Advert performance</h2><p>Compare impressions, engagement and click-through rates.</p></div><div className="super-overview-downloads"><button disabled={downLoading} onClick={() => handleDownload("xlsx")}><SuperIcon name="download" /> Excel</button><button disabled={downLoading} onClick={() => handleDownload("csv")}><SuperIcon name="download" /> CSV</button></div></div>
        {advertLoading ? (
          <div className="super-overview-state">Loading advert analytics...</div>
        ) : advertData?.length ? (
          <div className="super-overview-table-wrap"><table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Business Name</th>
                <th>Views</th>
                <th>Clicks</th>
                <th>Control</th>
              </tr>
            </thead>

            <tbody>{advertData?.map((data, index) => (
                <tr key={data.id || index}>
                  <td>{data.title}</td>
                  <td>{data.business_name}</td>
                  <td>{data?.views}</td>
                  <td>{data?.clicks}</td>
                  <td>{data?.ctr}</td>
                </tr>
              ))}
            </tbody></table></div>
        ) : (
          <div className="super-overview-state">No advert analytics are available yet.</div>
        )}
        </section>

        <section className="super-overview-card super-overview-access">
          <div className="super-overview-card-head"><div><span>ACCESS INTELLIGENCE</span><h2>Estate access-code activity</h2><p>Review weekly code performance for a selected estate.</p></div><label><small>Select estate</small><select
          value={selectedEstate}
          onChange={(e) => setSelectedEstate(e.target.value)}
          type="text"
          id="estates"
          name="estates"
        >{estates?.map((estate) => <option key={estate?.estate_id} value={estate?.estate_id}>{estate?.name}</option>)}</select></label></div>
          {selectedEstateData?.name && <div className="super-overview-selected-estate"><span></span>{selectedEstateData.name}</div>}

      {loading ? (
        <div className="super-overview-state">Loading access analytics...</div>
      ) : analyticsData?.length ? (
        <div className="super-overview-table-wrap"><table>
          <thead>
            <tr>
              <th>Week start</th>
              <th>Week end</th>
              <th>Codes generated</th>
              <th>Codes revoked</th>
              <th>Codes expired</th>
              <th>Codes validated</th>
              <th>Code Pending</th>
            </tr>
          </thead>

          <tbody>
            {analyticsData?.map((data, index) => (
              <tr key={`${data?.week_start}-${index}`}>
                <td>
                  {new Date(data?.week_start).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                  })}
                </td>
                <td>
                  {new Date(data?.week_end).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                  })}
                </td>
                <td>{data?.codes_generated}</td>
                <td>{data?.codes_revoked}</td>
                <td>{data?.codes_expired}</td>
                <td>{data?.codes_validated}</td>
                <td>{data?.codes_pending}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
      ) : (
        <div className="super-overview-state">No access analytics are available for this estate.</div>
      )}
          <div className="super-overview-top-user"><span className="super-overview-trophy"><SuperIcon name="trophy" /></span><div><small>HIGHEST ACCESS-CODE GENERATOR</small>{userCodeAna ? <><h3>{userCodeAna?.resident_name}</h3><p><strong>{userCodeAna?.codes_generated}</strong> codes generated <span>Rank #{userCodeAna?.rank}</span></p></> : <p>No resident ranking is available for this estate.</p>}</div></div>
        </section>
      </main>
    </WithSuperAuth>
  );
};

export default Overview;
